 <template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
      <!-- 一级菜单 -->
      <div 
        @click="deleteTagsView(item)" 
        v-if="hasOneShowingChildren(item.chirdMenuList) && !item.chirdMenuList[0].chirdMenuList" 
        :key="item.chirdMenuList[0].id">
        <el-menu-item :index="item.url+'/'+item.chirdMenuList[0].url" :class="{'submenu-title-noDropdown':!isNest}">
          <span v-if="item.chirdMenuList[0] && item.chirdMenuList[0].menuName">{{item.chirdMenuList[0].menuName}}</span>
        </el-menu-item>
      </div>
      
      <!-- 无子菜单 -->
      <div 
        @click="deleteTagsView(item)" 
        v-else-if="!item.chirdMenuList" 
        :key="item.id">
        <el-menu-item  class="no-drop-down-menu" :index="item.url" :class="{'submenu-title-noDropdown':!isNest}">
          <span v-if="item.menuName">{{item.menuName}}</span>
        </el-menu-item>
      </div>

      <!-- 带展开/收起按钮的子菜单 -->
      <div v-else :key="item.id" class="full-expand-menu">
        <div class="menu-title" @click="toggleMenu(item)">
          <span v-if="item.menuName">{{item.menuName}}</span>
          <!-- <i :class="expanded[item.id] ? 'icon-arrow-up' : 'icon-arrow-down'" @click.stop="toggleMenu(item)"></i> -->
          <i :class="expanded[item.id] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click.stop="toggleMenu(item)"></i>
        </div>
        <!-- 二级菜单，根据 expanded[item.id] 控制显示 -->
        <div class="submenu-two-columns" v-show="expanded[item.id]">
          <template v-for="child in item.chirdMenuList">
            <sidebar-item 
              :is-nest="true" 
              class="nest-menu" 
              v-if="child.chirdMenuList && child.chirdMenuList.length > 0" 
              :routes="[child]" 
              :key="child.id">
            </sidebar-item>
            <div 
              @click="deleteTagsView(item, child)" 
              v-else 
              :key="child.id" 
              class="menu-item-column" >
              <el-menu-item :index="item.url+'/'+child.url">
                <el-tooltip popper-class="hoverClass"
                              :disabled="child.menuName.length < 7"
                              :content="child.menuName"
                              placement="top-start">
                  <span class="submenu-item"> {{ child.menuName.length > 6 ? child.menuName.substring(0, 5) + '...' : child.menuName }}</span>
                </el-tooltip>
              </el-menu-item>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template> 

<script>
import * as services from './services'
export default {
  name: 'SidebarItem',
  props: {
    isFrame: {
      type: Object,
      default: () => {
        return {
          isUse: false
        }
      }
    },
    routes: {
      type: Array
    },
    expanded: {
      type: Object,
      default: () => ({})
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentLink: '',
      // expanded: JSON.parse(localStorage.getItem('menuExpandedState')) || {} // 初始化展开状态
      // expanded:{}
    }
  },
  mounted() {
    // 初始化所有一级菜单为展开状态
    // if (!localStorage.getItem('menuExpandedState')) {
      // this.initializeExpandedState(this.routes); // 初始化展开状态
    // }
  },
  methods: {
    toggleMenu(item) {
      this.$set(this.expanded, item.id, !this.expanded[item.id]);
      // localStorage.setItem('menuExpandedState', JSON.stringify(this.expanded)); // 更新本地存储
    },
    hasOneShowingChildren(children) {
      return false
    },
    async deleteTagsView(item, child) {
      // 当用户未完善开票信息时不能离开 财务信息编辑页面
       if(sessionStorage.getItem('NoOrderBillingService') ==1){
        this.$alert('您还未完善开票信息，请完善!', '提示', {
          confirmButtonText: '确定',
          type:'warning'
        })
        return false
      }
      let jiyituiData = null
      // 集易推 打开新窗口
      if(child && child.url.indexOf('jiyitui') > -1){
        jiyituiData = await services.redirect({}).toPromise()
        if (jiyituiData.data.code === 0){
          window.open(jiyituiData.data.data)
          return false
        }
      }
      
      // 供应链金融助力计划
      let popforuserwebData = null
      if (((item && item.url.indexOf('popforuserweb') > -1) || (child && child.url.indexOf('popforuserweb') > -1)) && this.$route.name === 'popforuserweb') {
        popforuserwebData = await services.unionFinanceRedirect({}).toPromise()
        // window.open(popforuserwebData.data.data)
        document.getElementsByTagName('iframe')[0].src = popforuserwebData.data.data
        return
      }

      //专题管理打开新窗口
      if(child && (child.menuName == '专题管理' || child.url.indexOf('legaoadminweb') >= 0)){
        if (location.hostname == 't.yunjiglobal.com' || location.hostname == 't-do-dev.yunjiglobal.com'){
          window.open(`//${location.hostname}/legaoadminweb`)
          return false
        }
        window.open(`//a.yunjiglobal.com/legaoadminweb`, '_blank')
        return false
      }
      //专题管理打开新窗口
      if(item.menuName == '数据罗盘'){
        if (location.hostname == 't.yunjiglobal.com' || location.hostname == 't-do-dev.yunjiglobal.com'){
          window.open(`//${location.hostname}/businesscompass`)
          return false
        }
        window.open(`//compass.yunjiglobal.com/businesscompass`)
          return false
      }
      //客服系统打开新窗口
      if (child && child.open) {
        if (window.location.hostname == 'seller.yunjiglobal.com') {
        window.open(`//popxinyunadmin.yunjiglobal.com${child.url.replace('..', '')}`)
        } else {
          window.open(child.url.replace('..', ''))
        }
        return
      }
      let view = this.$route
      let fg = false
      let winObj = window.location
      sessionStorage.removeItem('perUrl')
      this.isFrame.isUse = false
     
      // iframe 直接跳，
      if (child && /popConfigPage/.test(child.url)) {
        this.isFrame.isUse = true
        setTimeout(() => {
          this.$nextTick(() => {
            if (document.getElementsByTagName('iframe').length) {
              document.getElementsByTagName('iframe')[0].src = winObj.protocol + '//' + winObj.host + child.url
            }
          })
        }, 10)
        return
      }
       
      if (document.getElementsByTagName('iframe').length) {
        let host = ''
        if (this.$route.meta.host) {
          host = this.$route.meta.host
        } else {
          host = winObj.host
        }
        if (window.location.host == 't.yunjiglobal.com' || window.location.host == 't-do-dev.yunjiglobal.com') {
          host = window.location.host
        }
        let MessageType = ['popMarketing/discountEdit', 'popMarketing/shopCoupon', 'popMarketing/goodsCoupon']
        let src = document.getElementsByTagName('iframe')[0].src
         fg = MessageType.some(key => {
          if (src.includes(key)) {
            this.isJumpLink(item, child)
            this.listenChildMsg()
            return true
          }
          return false
        })
        let href = winObj.protocol + '//' + host
        if (!fg) {
          this.$store.dispatch('delAllViews')
          if(child && child.url.indexOf('jiyitui') >-1){
            if (jiyituiData.data.code === 1){
              document.getElementsByTagName('iframe')[0].src = jiyituiData.data.data
            }
          } else {
            if (this.$route.meta.src && this.$route.meta.src.indexOf('popWeb/workOrderManagement') >= 0) {
              console.log({work :this.$route.meta.src})
              if(this.$route.meta.host){host = this.$route.meta.host}else{host = window.location.host}
              if(window.location.host=='t.yunjiglobal.com' || window.location.host=='t-do-dev.yunjiglobal.com'){
                host = window.location.host
              }
              document.getElementsByTagName('iframe')[0].src = window.location.protocol + '//' + host + this.$route.meta.src + `?regionId=4&loginId=${ localStorage.getItem('popUserId')}`
            } else if (this.$route.meta.src && this.$route.meta.src.indexOf('popWeb/eventlist') >= 0) {
              if(this.$route.meta.host){host = this.$route.meta.host}else{host = window.location.host}
              if(window.location.host=='t.yunjiglobal.com' || window.location.host=='t-do-dev.yunjiglobal.com'){
                host = window.location.host
              }
              document.getElementsByTagName('iframe')[0].src = window.location.protocol + '//' + host + this.$route.meta.src + `?originType=3&origin=供应商&createRoleType=4&createRoleCode=${localStorage.getItem('storeCode')}&loginId=${ localStorage.getItem('popUserId')}`
            } else {
              document.getElementsByTagName('iframe')[0].src = href + view.meta.src
            }
          }
        }
      }

      if(fg){
        return
      }
      this.JumpTypes(item,child)
    },
    JumpTypes(item,child){
       this.$store.dispatch('delAllViews')
      if (this.hasOneShowingChildren(item.chirdMenuList) && !item.chirdMenuList[0].chirdMenuList) {
        this.$router.push({
          path: item.url + '/' + item.chirdMenuList[0].url,
          query: {

          }
        })
      } else if (!item.chirdMenuList) {
        this.$router.push({
          path: item.url ,
          query: {

          }
        })
      } else if (child) {
        this.$router.push({
          path: item.url + '/' + child.url,
          query: {

          }
        })
      }

    },
    isJumpLink(item, child) {
      let url=''
       if (this.hasOneShowingChildren(item.chirdMenuList) && !item.chirdMenuList[0].chirdMenuList) {
        url=item.url + '/' + item.chirdMenuList[0].url
      } else if (!item.chirdMenuList) {
        url=item.url
      } else if (child) {
         url=item.url + '/' + child.url
      }
      document.getElementsByTagName('iframe')[0].contentWindow.postMessage(
        {
          type: 'parentMessage',
          parentUrl: url,
          obj:{
            item,
            child
          }
        },
        '*'
      )
    },
    listenChildMsg() {
      let self = this
      window.addEventListener('message', function(e) {
        let data = e.data.msg
        let host = window.location.host
        if (data) {
          let view = self.$route
          host = ''
          if (self.$route.meta.host) {
            host = self.$route.meta.host
          } else {
            host = window.location.host
          }
          if (window.location.host == 't.yunjiglobal.com' || window.location.host == 't-do-dev.yunjiglobal.com') {
            host = window.location.host
          }
          if (data.isSignOut) {
              self.JumpTypes(data.obj.item,data.obj.child)
              if(document.getElementsByTagName('iframe').length){
                document.getElementsByTagName('iframe')[0].src = window.location.protocol + '//' + host + data.parentUrl
              }
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.menu-title {
  font-weight: bold;
  color: #4B4B4B !important;
  font-size: 15px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.no-drop-down-menu{
  font-weight: bold;
  color: #4B4B4B !important;
  font-size: 16px;
  display: flex;
  align-items: center; /* 垂直居中 */
  /* margin-bottom: 7px; */
}

.is-active {
  background: #dcdfe6 !important;
}
.menu-wrapper >>> .el-submenu__title i {
  color: #777 !important;
}
.full-expand-menu {
  /*margin-bottom: 10px;  大菜单项之间的间距调整为更紧凑*/
}


.submenu-two-columns {
  display: flex;
  flex-wrap: wrap;
  gap: 0; /* 子菜单项之间的间距减小为 5px */
}


.menu-item-column {
  flex: 0 0 50%; /* 子菜单项宽度调为 48%，让其更紧凑 */
  box-sizing: border-box;
  display: inline-block;
  padding: 0 0; /* 子菜单项的上下内边距减小 */
}

.nest-menu {
  /* flex: 1 1 48%; 嵌套菜单保持占据整行 */
}

/* 调整二级菜单项样式 */
.submenu-item {
  /* color: #fff; 字体颜色 */
  font-size: 13px; /* 二级菜单字体大小 */
  overflow: hidden; /* 隐藏溢出文本 */
  text-overflow: ellipsis; /* 溢出文本显示省略号 */
  white-space: nowrap; /* 防止换行 */
}


/* 取消选中时的背景色 */
.el-menu-item {
  line-height: 32px;
  height: 32px;
  /* display: inline-block; */
  padding-left: 12px !important;
  background-color: transparent !important; /* 去掉默认背景色 */
}

.el-menu-item.is-active {
  background-color: transparent !important; /* 去掉选中时的高亮背景 */
}

.el-menu-item:hover {
  background-color: transparent !important; /* 去掉 hover 时的背景色 */
}
</style>
